/* eslint-disable @typescript-eslint/no-explicit-any */
// this function handles tab and shift+tab to move focus outside the menu relative to the button
// either before or after the button in the tab order. I could have hard-coded this, but this way
// it will adapt if the button position in the tab order changes.
const focusRelativeToElement = (element: any, direction: number /* 1 | -1 */, avoidElement: any) => {
  // Build focusable list excluding menu items (since they are about to unmount)
  const selector =
    'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
  const focusables = Array.from(document.querySelectorAll(selector)).filter((el: any) => {
    if (el.offsetParent === null) {
      return false;
    }
    if (avoidElement && avoidElement.contains(el)) {
      return false;
    }
    return true;
  });
  const idx = focusables.indexOf(element);
  if (idx === -1) {
    return false;
  }
  const target: any = focusables[idx + direction];
  if (target) {
    target.focus();
    return true;
  }
  return false;
};

/**
 * Detects if the current window is running inside an iframe.
 * @returns {boolean} True if inside an iframe, false otherwise.
 */
const isInIframe = () => {
  try {
    return window.self !== window.top;
  } catch {
    // Cross-origin iframes throw an error when accessing window.top
    return true;
  }
};

export { focusRelativeToElement, isInIframe };
